module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-container-single element-non-bodymatter element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("Lights! Camera! Monsters?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Sometimes you go to the movies. And sometimes, the movies—and their monsters—come to you. At any moment, without notice, monsters once relegated to the screen become a reality. Aliens and demons, dragons and ghosts, werewolves, vampires, zombies, and seemingly ordinary people who are just plain evil.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Join award-winning authors Jonathan Maberry, Fran Wilde, David Gerrold, Rick Wilber and others for 23 all-new tales of haunted theaters, video gods, formidable demons, alien pizza, and delirious actors. Each story takes you to the silver screen with monstrous results.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Funny or grim, unsettling or cozy… You’ll laugh! You’ll sigh! You’ll scream!")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Grab popcorn—and good running shoes—and enjoy the show.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38549b6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/book-description.vue
// module id = 60
// module chunks = 0